/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */
import moment  from 'moment';

import { DiscountCodeEligibility } from '.';
import { DiscountCodeApplicability } from './../enums/discount-code-applicability.enum';
import { DEFAULT_DATE_FORMAT } from '@core/constants';

export class DiscountCode {
  constructor(
    public name: string = '',
    public code: string = '',
    public type: string = '',
    public value: number | null = null,
    public rule: string = '',
    public appliesTo: DiscountCodeApplicability | null = null,
    public eligibleFor: DiscountCodeEligibility[] = [],
    public usageCount: number = 0,
    public createdBy: string = '',
    public createdDate: string = moment().format(DEFAULT_DATE_FORMAT),
    public startDate: string | null = null,
    public endDate: string | null = null,
    public isActive = true,
    public id?: number
  ) {}
}
